import "../../CommonImports";
import "../../Core/core.css";
import "./MessageCard.css";
import * as React from "react";
import { CustomCard } from '../../Card';
import { MessageBar } from '../../MessageBar';
import { css } from '../../Util';
export const MessageCard = props => {
    const { buttonProps, children, className, severity, iconProps, messageBarClassName, onDismiss, role } = props;
    return (React.createElement(CustomCard, { className: css(className, "bolt-messagecard") },
        React.createElement(MessageBar, { buttonProps: buttonProps, children: children, className: messageBarClassName, iconProps: iconProps, onDismiss: onDismiss, severity: severity, role: role })));
};
MessageCard.displayName = "MessageCard";
